import * as yup from "yup";
export const lineItemInvoiceSchema = yup.object().shape({
  particulars: yup.string(),
  totalWithoutGst: yup.number(),
  totalWithGst: yup.number(),
  itemUnit: yup.string(),
  itemQuantity: yup.number(),
  discount: yup.number(),
  HSN: yup.string(),
  itemPrice: yup.number(),
  gstRate: yup.number(),
});

export const addressSchema = {
  addressLine1: yup.string(),
  addressLine2: yup.string(),
  city: yup.string(),
  pincode: yup.string(),
  state: yup.string(),
  country: yup.string(),
};
export const billingAddressSchema = {
  addressLine1: yup.string().required(),
  addressLine2: yup.string(),
  city: yup.string().required(),
  pincode: yup.string().required(),
  state: yup.string().required(),
  country: yup.string().required(),
};

export const ClientInvoiceSchema = yup.object().shape({
  clproject: yup.string(),
  clquotation: yup.string(),
  invoiceType: yup.string(),
  invoiceDate: yup.date(),
  businessName: yup.string().required("Required"),
  contactPersonName: yup.string().required("Required"),
  phoneNumber: yup.number(),
  gstNumber: yup.string(),
  address: yup.string(),
  countryOfSupply: yup.string(),
  placeOfSupply: yup.string(),
  invoiceFor: yup.string(),
  totalAmountIncGst: yup.number(),
  subTotal: yup.number(),
  totalGst: yup.number(),
  notes: yup.string(),
  generatedBy: yup.string(),
  pdfStatus: yup.boolean(),
  lineItems: yup.array().of(lineItemInvoiceSchema),
  shippingAddress: yup.object().shape(addressSchema),
  billingAddress: yup.object().shape(billingAddressSchema),
  clId: yup.string(),
  manualInvoiceNumber: yup.string(),
  terms_conditions: yup.string(),
});
export const ClientInvoiceEditSchema = yup.object().shape({
  clproject: yup.string(),
  clquotation: yup.string(),
  invoiceType: yup.string(),
  invoiceDate: yup.date(),
  businessName: yup.string().required("Required"),
  contactPersonName: yup.string().required("Required"),
  phoneNumber: yup.number(),
  gstNumber: yup.string(),
  address: yup.string(),
  countryOfSupply: yup.string(),
  placeOfSupply: yup.string(),
  invoiceFor: yup.string(),
  totalAmountIncGst: yup.number(),
  subTotal: yup.number(),
  totalGst: yup.number(),
  notes: yup.string(),
  generatedBy: yup.string(),
  pdfStatus: yup.boolean(),
  lineItems: yup.array().of(lineItemInvoiceSchema),
  shippingAddress: yup.object().shape(addressSchema),
  billingAddress: yup.object().shape({
    addressLine1: yup.string(),
    addressLine2: yup.string(),
    city: yup.string(),
    state: yup.string(),
    country: yup.string(),
  }),
  clId: yup.string(),
});
